import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  children,
  className = '',
  ...props
}) => {
  const baseClasses = 'flex-1 px-4 py-4 border font-medium text-xs tracking-widest uppercase cursor-pointer transition-all duration-300';
  
  const variantClasses = {
    primary: 'bg-primary text-white border-primary hover:opacity-90',
    secondary: 'bg-transparent text-secondary border-border hover:border-primary hover:text-primary',
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
